import { type ReactNode } from 'react'
import { Heading, Text } from '@/components/ui'

/** Standard page header: title + optional subtitle on the left, actions right. */
export function PageHeading({
  title,
  subtitle,
  actions,
}: {
  title: string
  subtitle?: string
  actions?: ReactNode
}) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div>
        <Heading>{title}</Heading>
        {subtitle && <Text className="mt-1">{subtitle}</Text>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  )
}
